export { default } from './PeakLogoBadge';
